// 通过 Vue.extend 的方式，创建一个 vue instance 并插入到 body 里面，来实现 dialog
// 这种实现，可以将 dialog 的dom层级直接插到body的最外层

// 使用方式
// let dialog = createDilog(Component)
// dialog()  // open the dialog
import Vue from 'vue'
import { createStore } from '@/store'
import i18n from '@/i18n'

const createDialog = component => {
  let DialogConstructor = Vue.extend(component)

  // a hack way to overcome shortage of i18n
  // vuei18n的fallback机制，是需要instance的meessages只包含这一层级vue的messages，_root进行fallback
  // Vue.extend会让plugins里面的vue instance作为根instance，i18n为根i18n
  // 所以需要hack way来重置instance的messages
  let instance = new DialogConstructor({
    store: createStore(),
    i18n: {
      root: i18n,
      fallbackLocale: i18n.fallbackLocale,
      silentTranslationWarn: i18n.silentTranslationWarn
    }
  })

  let wakeup = (opts = {}) => {
    if (!instance.$el) {
      instance.$mount(document.createElement('div'))
      document.body.appendChild(instance.$el)
    }

    Vue.nextTick(() => {
      instance.open(opts)
    })
  }
  return wakeup
}

export { createDialog }



// WEBPACK FOOTER //
// ./src/assets/scripts/dialog.js